import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/src/app/points/season-one/page.tsx");
